import { BaseHandler } from '../base.handler';
import AlertsAPI from 'api/Squares/Alerts.api';
import {
  setIsLoading,
  appendAlerts,
  acknowledgeAlert,
} from 'store/SquaresStore/AlertsSquares.slice';
import type { AlertData, AlertFeedbackPayload } from 'types/squares.type';
import { useAppSelector } from 'store/hook';

export default class SquaresAlertHandler extends BaseHandler {
  private readonly apiWorkOrders: AlertsAPI;
  private readonly customer = useAppSelector((state) => state.persistedReducer)
    .customer.code;

  constructor() {
    super();
    this.apiWorkOrders = new AlertsAPI();
  }

  async getAllAlerts(customerId: string): Promise<AlertData[]> {
    try {
      this.dispatch(setIsLoading(true));
      const { notifications } = await this.apiWorkOrders.getAlerts(customerId);

      this.dispatch(appendAlerts(notifications));
      this.handleSuccess();
      this.dispatch(setIsLoading(false));

      return notifications;
    } catch (error: any) {
      let msg: string = '';

      if (error.isAxiosError) {
        msg = error.response.data.message as string;
      }

      this.handleError(
        'An error occured while retrieving the squares : ' + msg
      );
      this.dispatch(setIsLoading(false));
      return [];
    }
  }

  async acknowledgeAlert(notificationId: string) {
    this.dispatch(setIsLoading(true));
    try {
      const response = await this.apiWorkOrders.acknowledgeAlert(
        notificationId
      );
      this.dispatch(acknowledgeAlert(notificationId));
      this.dispatch(setIsLoading(false));
      this.handleSuccess();
      return response;
    } catch (error: any) {
      let msg: string = '';

      // Extract the error message from AxiosErrors
      // TODO: Look into other errors that can be thrown
      if (error.isAxiosError) {
        msg = error.response.data.message as string;
      }

      this.dispatch(setIsLoading(false));
      this.handleError(
        'An error occurred while acknowledging squares alert : ' + msg
      );
      return [];
    }
  }

  async submitAlertFeedback(
    notificationId: string,
    userFeedback: AlertFeedbackPayload
  ) {
    this.dispatch(setIsLoading(true));
    try {
      const response = await this.apiWorkOrders.submitAlertFeedback(
        notificationId,
        userFeedback
      );
      this.dispatch(setIsLoading(false));
      this.handleSuccess();
      return response;
    } catch (error: any) {
      let msg: string = '';

      // Extract the error message from AxiosErrors
      // TODO: Look into other errors that can be thrown
      if (error.isAxiosError) {
        msg = error.response.data.message as string;
      }

      this.dispatch(setIsLoading(false));
      this.handleError(
        'An error occurred while submitting feedback squares alert : ' + msg
      );
      return [];
    }
  }
}
